module.exports = __webpack_public_path__ + "img/strawberry-spinach-salad.6478b217.jpg";